export const chaptersByCourseIdSelector = state => state.entities.chapters.byCourseId;
